import { NotificationMessages } from '../types';

export const notificationHI: NotificationMessages = {
    'app.notification.title': 'सूचना केंद्र',
    "app.notification.generate_file": "हम आपकी फ़ाइल तैयार कर रहे हैं। जैसे ही यह तैयार होगी, आपको इसे डाउनलोड करने के लिए एक सूचना मिलेगी।",
    'app.notification.download_program': 'प्रोग्राम विवरण डाउनलोड करें',
};
